import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.svg";
import phoneIcon from "../../assets/phone-icon.svg";
// import { Form } from "../Form/Form";

export function Contact() {
  return (
    <Container id="contact">
      <header>
        <h2>Contact</h2>
        <p>Ready to discuss your QA testing needs? </p>
        <p>Contact me for a free consultation on software quality assurance.</p>
      </header>
      <div className="contacts">
        <div>
          <a href="mailto:m.muzammilrasheed@gmail.com">
            <img src={emailIcon} alt="Email" />
          </a>
          <a href="mailto:m.muzammilrasheed@gmail.com">
            m.muzammilrasheed@gmail.com
          </a>
        </div>
        <div>
          <a href="tel:+923208460396">
            <img src={phoneIcon} alt="Phone No" />
          </a>
          <a href="tel:+923208460396">+92 320 8460396</a>
          <a href="tel:+971522387454">+971 522387454</a>
        </div>
        <div className="address">
          <a
            href="https://maps.google.com/?q=304+ABEER+ALNOOR+CLINIC+FRIJMURAR+DEIRA+DUBAI"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Address location"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden
            >
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
          </a>
          <a
            href="https://maps.google.com/?q=304+ABEER+ALNOOR+CLINIC+FRIJMURAR+DEIRA+DUBAI"
            target="_blank"
            rel="noopener noreferrer"
          >
            304 ABEER ALNOOR CLINIC FRIJMURAR DEIRA DUBAI
          </a>
        </div>
      </div>
      {/* <Form></Form> */}
    </Container>
  );
}
